import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;
  margin-top: 12px;
  margin-bottom: 16px;
  & > * {
    margin-right: 16px;
  }
`

const ActionButtons = ({ children, className }) => {
  return (
    <StyledWrapper className={className} data-test='action-buttons'>
      {children}
    </StyledWrapper>
  )
}

ActionButtons.propTypes = {
  children: PropTypes.node,
}

export default ActionButtons
